<ng-template [ngIf]="selectedValue?.start && selectedValue?.end">
  <span class="phx-web-type-body-medium phx-month-picker-selected-range">
    {{ formatMonth(selectedValue.start) }}
    <ng-container *ngIf="selectedValue.start.getFullYear() !== selectedValue.end.getFullYear()">{{
      formatYear(selectedValue.start)
    }}</ng-container>
    - {{ formatMonth(selectedValue.end) }}
    <ng-container *ngIf="selectedValue.start.getFullYear() !== selectedValue.end.getFullYear()">{{
      formatYear(selectedValue.end)
    }}</ng-container>
  </span>
  <i phx-icon [phxIcon]="bulletIcon"></i>
</ng-template>
<span class="phx-clear-text phx-web-type-body-medium" tabindex="0" (keydown.enter)="onClear()" (click)="onClear()">
  Clear
</span>
